import { render } from "./guidanceDetails.vue?vue&type=template&id=16c7233d&scoped=true"
import script from "./guidanceDetails.vue?vue&type=script&lang=js"
export * from "./guidanceDetails.vue?vue&type=script&lang=js"

import "./guidanceDetails.vue?vue&type=style&index=0&id=16c7233d&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c7233d"]])

export default __exports__